import { render, staticRenderFns } from "./fengxian.vue?vue&type=template&id=6f52cba4&scoped=true"
import script from "./fengxian.vue?vue&type=script&lang=js"
export * from "./fengxian.vue?vue&type=script&lang=js"
import style0 from "./fengxian.vue?vue&type=style&index=0&id=6f52cba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52cba4",
  null
  
)

export default component.exports